const RELATIVE_TIME_MAX_MS = 24 * 60 * 60 * 1000

export function formatComplianceDocumentLastSavedAt(
  savedAt: Date,
  locale: string,
  now: Date = new Date()
): string {
  const diffMs = now.getTime() - savedAt.getTime()
  if (diffMs < 0) {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: 'short',
      timeStyle: 'short',
    }).format(savedAt)
  }

  if (diffMs < RELATIVE_TIME_MAX_MS) {
    const diffSeconds = Math.round(diffMs / 1000)
    const relativeTimeFormatter = new Intl.RelativeTimeFormat(locale, {
      numeric: 'auto',
    })

    if (diffSeconds < 60) {
      return relativeTimeFormatter.format(-diffSeconds, 'second')
    }

    const diffMinutes = Math.round(diffSeconds / 60)
    if (diffMinutes < 60) {
      return relativeTimeFormatter.format(-diffMinutes, 'minute')
    }

    const diffHours = Math.round(diffMinutes / 60)
    return relativeTimeFormatter.format(-diffHours, 'hour')
  }

  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(savedAt)
}

export function parseComplianceDocumentSavedAt(
  generatedAt?: string,
  createdAt?: string
): Date | null {
  const raw = generatedAt ?? createdAt
  if (raw == null || raw.length === 0) {
    return null
  }
  const parsed = new Date(raw)
  if (Number.isNaN(parsed.getTime())) {
    return null
  }
  return parsed
}
